// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__hZJPj","content":"Consent_content__3K9sS","footer":"Consent_footer__2vfFq"};